// Simple engine that forwards actions to the RN shell via postMessage.
// No native imports, so webpack is happy.

const listeners = {};

function emit(event, payload) {
  if (listeners[event]) {
    listeners[event].forEach((cb) => cb(payload));
  }
}

function post(msg) {
  try {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(msg));
    }
  } catch (e) {
    console.warn('[VOIP][BRIDGE] post failed', e); // eslint-disable-line no-console
  }
}

export const nativeBridgeClient = {
  async init(config) {
    post({ type: 'nativeVoipInit', payload: config });
  },

  async start() {
    post({ type: 'nativeVoipStart' });
  },

  async stop() {
    post({ type: 'nativeVoipStop' });
  },

  on(event, cb) {
    if (!listeners[event]) listeners[event] = new Set();
    listeners[event].add(cb);
  },

  off(event, cb) {
    if (listeners[event]) listeners[event].delete(cb);
  },

  // Call control
  call(target) {
    post({ type: 'nativeVoipCall', payload: { target } });
  },

  answer() {
    post({ type: 'nativeVoipAnswer' });
  },

  reject() {
    post({ type: 'nativeVoipReject' });
  },

  hangup() {
    post({ type: 'nativeVoipHangup' });
  },

  toggleMute() {
    post({ type: 'nativeVoipToggleMute' });
  },

  toggleHold() {
    post({ type: 'nativeVoipToggleHold' });
  },

  sendDTMF(tone) {
    post({ type: 'nativeVoipDTMF', payload: { tone } });
  },

  blindTransfer(target) {
    post({ type: 'nativeVoipBlindTransfer', payload: { target } });
  },

  startConsultTransfer(target) {
    post({ type: 'nativeVoipStartConsult', payload: { target } });
  },

  completeConsultTransfer() {
    post({ type: 'nativeVoipCompleteConsult' });
  },

  cancelConsultTransfer() {
    post({ type: 'nativeVoipCancelConsult' });
  },

  // These will be called by RN via postMessage → VoipNativeBridgeListener
  _emitFromNative(event, payload) {
    emit(event, payload);
  },
};

export default nativeBridgeClient;
